import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import ListIcon from "@mui/icons-material/List";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "./Language";
import Stack from "@mui/material/Stack";
import GridViewIcon from "@mui/icons-material/GridView";
import { useLSSearch, ViewType } from "./pages/search/ls/LSSearch";

interface ResultsViewToggleProps {}

// https://m3.material.io/components/segmented-buttons/accessibility
// use an outline with at least 3:1 contrast with the surface
export const HigherContrastToggleButtonGroup = styled(ToggleButtonGroup)(
  () => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      borderColor: "rgba(0, 0, 0, 0.42)",
    },
  })
);

export const ResultsViewToggle = ({}: ResultsViewToggleProps) => {
  const {
    setView,
    searchParams: { view },
  } = useLSSearch();
  const { translate } = useLanguage();

  const handleChange = React.useCallback(
    (event: React.MouseEvent<HTMLElement>, newValue: ViewType | null) => {
      if (!newValue) return; // don't allow deselection
      setView(newValue);
    },
    [setView]
  );

  return (
    <HigherContrastToggleButtonGroup
      color="secondary"
      value={view}
      onChange={handleChange}
      exclusive
      size="small"
      aria-label={translate("viewAs")}
    >
      <ToggleButton value={ViewType.list} sx={{ pr: "12px", pl: "12px" }}>
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {view === ViewType.list ? <CheckIcon /> : <ListIcon />}
          {translate("views_list")}
        </Stack>
      </ToggleButton>
      <ToggleButton value={ViewType.grid} sx={{ pr: "12px", pl: "12px" }}>
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {view === ViewType.grid ? <CheckIcon /> : <GridViewIcon />}
          {translate("views_grid")}
        </Stack>
      </ToggleButton>
    </HigherContrastToggleButtonGroup>
  );
};
